import classNames from 'classnames';
import React, {Fragment} from 'react';
import {startCase} from 'lodash';

import {Button, Dropdown, DropdownItem, Icon, Text} from '@albert-io/atomic';

export type Value = 'all' | 'closed' | 'open' | 'toDo';

interface DropdownOption {
  subtext?: string;
  value: Value;
}

interface Props extends PropsWithClassNameOptional {
  disabled: boolean;
  isScopedToClassroom: boolean;
  onValueChange: (value: Value) => void;
  value: Value;
}

export default function AssignmentStatusDropdown({
  className,
  disabled,
  isScopedToClassroom,
  onValueChange,
  value: valueProp
}: Props) {
  const options: DropdownOption[] = [
    {
      value: 'toDo'
    },
    {
      subtext: 'Assignments you can still submit, including past due.',
      value: 'open'
    },
    {
      value: 'closed'
    }
  ];

  if (isScopedToClassroom) {
    options.unshift({
      value: 'all'
    });
  }

  return (
    <Dropdown
      className={className}
      closeOnItemClicked
      contentClassName='p-x1'
      trayClassName='w-[275px]'
      trigger={
        <Button
          className='items-center gap-x1-quarter'
          color='secondary'
          disabled={disabled}
          variant='outlined'
        >
          {startCase(valueProp)}
          <Icon icon='caret-down' />
        </Button>
      }
    >
      {options.map(({subtext, value}) => (
        <Fragment key={value}>
          <DropdownItem
            bold={false}
            className={classNames('items-center justify-start rounded-x1 px-x1-half py-x1', {
              'background-info-subtle': valueProp === value
            })}
            icon={valueProp === value ? 'check' : undefined}
            iconColor='info'
            onClick={() => {
              onValueChange(value);
            }}
            subtext={subtext}
          >
            <Text>{startCase(value)}</Text>
          </DropdownItem>
          {value === 'toDo' && <hr className='m-x1' />}
        </Fragment>
      ))}
    </Dropdown>
  );
}
